import HTTP_USER_SERVICE from "../config/axios/axios-user.config";
import { AccessRightModel } from "../model/access-right.model";

export const getAllApi = () => {
  return HTTP_USER_SERVICE.get<AccessRightModel[]>("/access-rights");
};
